<template>
    <div class="main">
        <!-- 情報站標題 -->
        <div class="main-title">
            <b-row align-h="between">
                <b-col cols="auto">
                    <h2 class="px-3">智慧農場</h2>
                </b-col>
                <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>
            </b-row>
        </div>
        <div class="main-content">
            <b-container>
                <h3>{{ detailTitle }}</h3>
                <b-row cols="1" cols-md="2" cols-lg="2" class="pb-5">
                    <b-col class="pb-3 pb-md-0">
                        <b-carousel id="carousel-fade" style="text-shadow: 0px 0px 2px #000" fade indicators
                            img-width="1024" img-height="480">
                            <b-carousel-slide v-for="(data, index) in imgData" :key="index" :caption="''"
                                :img-src="data.src"></b-carousel-slide>
                        </b-carousel>
                    </b-col>
                    <b-col>
                        <p>
                            {{ detailDescript }}
                        </p>
                    </b-col>
                </b-row>
            </b-container>
            <div class="sub-content py-3">
                <!-- (已登入) -->
                <b-container v-show="checkLogin()">
                    <h3 class="color-brown">{{ device_id == "N20230906003"?"大氣溫度":"土壤溫度" }}</h3>
                    <div class="data-block shadow">
                        <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                            <div id="chart_temperature"></div>
                        </div>
                    </div>
                    <h3 class="color-blue">土壤氮磷鉀即時監測數據</h3>
                    <div class="data-block shadow" style="overflow-x: hidden; overflow-y: auto;overflow:scroll; max-height:315px;">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="ths">timestamp</th>
                                    <th class="thm">氮含量(N)</th>
                                    <th class="thm">磷含量(P)</th>
                                    <th class="thm">鉀含量(K)</th>
                                    <th class="the">土壤電導度</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr :class="(key % 2 == 0)?'even-row':'odd-row'" v-for="(value, key) in soil" :value="value.value" :key="'soil' + key"> 
                                    <td class="tdm"><span>{{ value.time }}</span></td>
                                    <td class="tdm"><span>{{ value.soil_n }} mg/kg</span></td>
                                    <td class="tdm"><span>{{ value.soil_p }} mg/k</span></td>
                                    <td class="tdm"><span>{{ value.soil_k }} mg/k</span></td>
                                    <td class="tdm"><span>{{ value.soil_ec }} μs/cm</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h3 class="color-deepgreen">農業感測器感測資料</h3>
                    <div class="data-block shadow" style="overflow-x: hidden; overflow-y: auto;overflow:scroll; max-height:315px;">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <!--
                                    <th class="ths">station_id</th>
                                    -->
                                    <th class="ths">timestamp</th>
                                    <th class="thm">{{ device_id == "N20230906003"?"大氣溫度":"土壤溫度" }}</th>
                                    <th class="the">{{ device_id == "N20230906003"?"相對溼度":"土壤濕度" }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr :class="(key % 2 == 0)?'even-row':'odd-row'" v-for="(value, key) in soil" :value="value.value" :key="'soil' + key">
                                    <!--
                                    <td class="tdm"><span>{{ value.device_id }}</span></td>
                                    -->
                                    <td class="tdm"><span>{{ value.time }}</span></td>
                                    <td class="tdm"><span>{{ value.temperature }} °C</span></td>
                                    <td class="tdm"><span>{{ value.humidity }} %</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <b-row class="justify-content-center py-3">
                        <b-col cols="auto"><b-button pill variant="primary" to="../Farm_new"
                                class="px-4">返回智慧農場</b-button></b-col>
                    </b-row>
                </b-container>
        
                <!-- (未登入) -->
                <div class="w3-container w3-display-container" v-show="!checkLogin()">
                    <div class="w3-row" style="font-size: 20px; font-weight: 800; margin: 5px 5px; text-align: center;">此功能需要登入才能使用，請點按鈕前往登入頁面</div>
                    <div class="w3-container w3-center">
                        <img src="static/img/img_avatar.png" alt="Avatar" style="width:300px">
                        <div class="w3-row title-chart">訪客(未登入)</div>

                        <div class="w3-section">
                            <button class="w3-button w3-green w3-round-large" style="width:300px" @click="goLogin">前往登入</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        this.paramValue = this.$route.params.param;
        // console.log(this.paramValue);
        //this.items[2].text = this.paramValue;
    },
    data() {
        return {
            paramValue: null,
            items: [
                {
                    text: '首頁',
                    href: '#/'
                },
                {
                    text: '智慧農場',
                    href: '#/Farm_new'
                },
                {
                    text: '花田囍咖啡農場',
                    active: true
                }
            ],
            detailTitle: "",
            detailDescript:"",
            /*
            imgData: [
                { title: '花田囍咖啡農場1', url: "#", src: "../static/img/green-field.jpg" },
                { title: '花田囍咖啡農場2', url: "#", src: "../static/img/green-field.jpg" },
                { title: '花田囍咖啡農場3', url: "#", src: "../static/img/green-field.jpg" },
                { title: '花田囍咖啡農場4', url: "#", src: "../static/img/green-field.jpg" },
                { title: '花田囍咖啡農場5', url: "#", src: "../static/img/green-field.jpg" },
                { title: '花田囍咖啡農場6', url: "#", src: "../static/img/green-field.jpg" },
                { title: '花田囍咖啡農場7', url: "#", src: "../static/img/green-field.jpg" },
                { title: '花田囍咖啡農場8', url: "#", src: "../static/img/green-field.jpg" }
            ],
            */
            imgData: [],
            soil:[],
            device_id:"",

            //api 取得感測值(實際數據)
            apiCurl: (data) => this.userRequest.post("/API/Default/Curl", data),
            //api 取得感測值(一天數據)
            apiCurl2: (data) => this.userRequest.post("/API/Default/Curl2", data),
            //api 取得智慧農場
            apiGetWisdomFarm: (data) => this.userRequest.post("/API/Default/GetWisdomFarm", data),    

        }
    },
    components: {
        //Login_sub
    },
    updated() {
    },
    mounted() {
        // console.log(this.$route.query.id);
        this.checkLogin();
        //this.getCurl();
        this.getGetWisdomFarm();
    },
    methods: {

        //取得感測值(實際數據)
        getCurl:function()
        {
            this.soil = [];

            this.apiCurl({
                num:100,
                device_id:this.device_id
            })
            .then((res)=>{

                const data = JSON.parse(res.data);

                console.log(data);
                var now_24hr = Date.now(); 
                now_24hr = now_24hr - 86400000;

                for(var i=0 ; i<data.length ; i++)
                {
                    var item = data[i];
                    var device_id = item.message["device id"];
                    var device_type = item.message["device type"];
                    var date2 = item.date2;

                    date2 = Date.parse(date2);

                    //改成只抓一天內的資料
                    if(date2 >= now_24hr)
                    {
                        //大力有機農場
                        if(device_id == "N20230906003")
                        {
                            this.soil.push({
                                //設備序號
                                device_id:device_id,
                                //設備種類
                                device_type:device_type,
                                //感測時間
                                time:item.date2,
                                //土壤鉀(k)
                                soil_k:item.message.soil_k,
                                //土壤氮(n)
                                soil_n:item.message.soil_n,
                                //土壤磷(p)
                                soil_p:item.message.soil_p,
                                //土壤電導度(ec)
                                soil_ec:item.message.soil_ec, 
                                //土壤溫度
                                temperature:item.message.temperature, 
                                //土壤濕度
                                humidity:item.message.humidity_rel, 
                            });
                        }
                        else
                        {
                            this.soil.push({
                                //設備序號
                                device_id:device_id,
                                //設備種類
                                device_type:device_type,
                                //感測時間
                                time:item.date2,
                                //土壤鉀(k)
                                soil_k:item.message.soil_k,
                                //土壤氮(n)
                                soil_n:item.message.soil_n,
                                //土壤磷(p)
                                soil_p:item.message.soil_p,
                                //土壤電導度(ec)
                                soil_ec:item.message.soil_ec, 
                                //土壤溫度
                                temperature:item.message.soil_t, 
                                //土壤濕度
                                humidity:item.message.soil_mc,  
                            });
                        }
                    }
                }

                //將順序顛倒(因該越早在左邊，越晚在右邊)
                this.soil = this.soil.reverse();
                this.setChartTemperature();
                
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //取得感測值(一天數據)
        getCurl2:function()
        {
            this.soil = [];

            this.apiCurl2({
                device_id:this.device_id
            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                console.log(data);
                
                if(data.length > 0)
                {
                    for(var i=0 ; i<data.length ; i++)
                    {
                        var item = data[i];
                        console.log(item);

                        //大力有機農場
                        if(item.device_id == "N20230906003")
                        {
                            this.soil.push({
                                //設備序號
                                device_id:item.device_id,
                                //設備種類
                                device_type:item.device_type,
                                //感測時間
                                time:item.date,
                                //土壤鉀(k)
                                soil_k:item.soil_k,
                                //土壤氮(n)
                                soil_n:item.soil_n,
                                //土壤磷(p)
                                soil_p:item.soil_p,
                                //土壤電導度(ec)
                                soil_ec:item.soil_ec, 
                                //土壤溫度
                                temperature:item.temperature, 
                                //土壤濕度
                                humidity:item.humidity_rel, 
                            });
                        }
                        else
                        {
                            this.soil.push({
                                //設備序號
                                device_id:item.device_id,
                                //設備種類
                                device_type:item.device_type,
                                //感測時間
                                time:item.date,
                                //土壤鉀(k)
                                soil_k:item.soil_k,
                                //土壤氮(n)
                                soil_n:item.soil_n,
                                //土壤磷(p)
                                soil_p:item.soil_p,
                                //土壤電導度(ec)
                                soil_ec:item.soil_ec, 
                                //土壤溫度
                                temperature:item.soil_t, 
                                //土壤濕度
                                humidity:item.soil_mc,  
                            });
                        }
                    }
                    
                    this.setChartTemperature();

                }

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //取得智慧農場
        getGetWisdomFarm:function()
        {
            this.soil = [];

            this.apiGetWisdomFarm({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);              
                const list = data.list;

                for(var i=0;i < list.length ; i++){

                    var item = list[i];
                    if(item.sn == this.paramValue)
                    {
                        this.detailTitle = item.name;
                        this.detailDescript = item.descript;
                        this.items[2].text = item.name;
                        this.device_id = item.device_id;
                        this.imgData = [];
                        for(var j=0 ; j<item.list.length ; j++)
                        {
                            this.imgData.push({

                                title: item.list[j].old, 
                                url: "#", 
                                src: "https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_farm/" + item.sn + "/" + item.list[j].src,
                            });
                        }

                        //this.getCurl();
                        this.getCurl2();
                    }
                }
            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //設定圖表(溫度)
        setChartTemperature:function(){

            var data = [];
            var categories = []

            for(var i=0 ; i<this.soil.length ; i++)
            {
                var item = this.soil[i];
                data.push(item.temperature);
                categories.push(item.time);
            }

            var options = {
                series: [{
                    name: "溫度",
                    data: data
                }],
                colors: [
                    "#64A953",
                ],
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    //曲線
                    curve: 'smooth'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    //type: "datetime",
                    tickAmount: 5,
                    categories: categories,
                }
            };

            var chart = new window.ApexCharts(document.querySelector("#chart_temperature"), options);
            chart.render();

        },

    },
    watch: {
    }
}
</script>
<style lang="scss">

.custom-table {
    width: 90%;
    text-align: center;
    margin-top: 20px;
    border-collapse: collapse;
    border-radius: 10px;
    /* 表格的四角弧度 */
    overflow: hidden;
    /* 陰影不會超出表格 */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

    /* 陰影效果 */
    th {
        padding: 10px;
        text-align: center;
        font-weight: bold;
        background-color: #f0f0f0;
    }

    td {
        padding: 10px;
        text-align: center;
        font-weight: bold;
    }

    .ths {
        background-color: #19547b;
        border-radius: 10px 0px 0px 0px;
        border-right: 1px solid #ffffff;
        color: #ffffff;
    }

    .thm {
        background-color: #19547b;
        border-right: 1px solid #ffffff;
        color: #ffffff;
    }

    .the {
        background-color: #19547b;
        border-radius: 0px 10px 0px 0px;
        color: #ffffff;
    }

    .tds {
        border-radius: 0px 0px 0px 10px;
    }

    .tdm {
        border-right: 1px solid #ffffff;
    }

    .tde {
        border-radius: 0px 0px 10px 0px;
    }

    .even-row {
        background-color: #ffffff;
        /* 偶數行 */
    }

    .odd-row {
        background-color: #cfe6fcaf;
        /* 奇數行 */
    }
}
</style>